var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaddedJumper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3B55E6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97,117H23c-0.55,0-1-0.45-1-1v-16c0-0.55,0.45-1,1-1h74c0.55,0,1,0.45,1,1v16C98,116.55,97.55,117,97,117z  M24,115h72v-14H24V115z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97,101H23c-0.55,0-1-0.45-1-1V84c0-0.55,0.45-1,1-1h74c0.55,0,1,0.45,1,1v16C98,100.55,97.55,101,97,101z  M24,99h72V85H24V99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97,85H23c-0.55,0-1-0.45-1-1V68c0-0.55,0.45-1,1-1h74c0.55,0,1,0.45,1,1v16C98,84.55,97.55,85,97,85z  M24,83h72V69H24V83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97,69H23c-0.55,0-1-0.45-1-1V52c0-0.55,0.45-1,1-1h74c0.55,0,1,0.45,1,1v16C98,68.55,97.55,69,97,69z  M24,67h72V53H24V67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,117c-0.55,0-1-0.45-1-1V44c0-0.55,0.45-1,1-1c0.55,0,1,0.45,1,1v72C61,116.55,60.55,117,60,117z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.8,13H47.2c-0.41,0-0.78-0.25-0.93-0.63l-3.2-8c-0.12-0.31-0.08-0.66,0.1-0.93C43.36,3.17,43.67,3,44,3 h32c0.33,0,0.64,0.16,0.83,0.44c0.19,0.27,0.22,0.62,0.1,0.93l-3.2,8C73.58,12.75,73.21,13,72.8,13z M47.88,11h24.25l2.4-6H45.48 L47.88,11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,45c-0.17,0-0.33-0.04-0.49-0.13c-0.44-0.25-0.62-0.78-0.44-1.24l16-40c0.12-0.31,0.4-0.54,0.73-0.61 c0.34-0.07,0.67,0.04,0.91,0.27l8,8c0.35,0.35,0.39,0.91,0.09,1.31l-24,32C60.61,44.86,60.31,45,60,45z M76.37,5.78L63.74,37.35 l18.94-25.26L76.37,5.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,45c-0.41,0-0.78-0.25-0.93-0.63l-3.2-8c-0.21-0.51,0.04-1.09,0.56-1.3c0.51-0.21,1.09,0.04,1.3,0.56 L60,41.31l2.27-5.68c0.21-0.51,0.79-0.76,1.3-0.56c0.51,0.21,0.76,0.79,0.56,1.3l-3.2,8C60.78,44.75,60.41,45,60,45z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97,53H23c-0.55,0-1-0.45-1-1v-4c0-0.55,0.45-1,1-1c6.07,0,11-4.93,11-11c0-0.55,0.45-1,1-1h19 c0.31,0,0.61,0.15,0.8,0.4l5.2,6.93l5.2-6.93c0.19-0.25,0.49-0.4,0.8-0.4h19c0.55,0,1,0.45,1,1c0,6.07,4.93,11,11,11 c0.55,0,1,0.45,1,1v4C98,52.55,97.55,53,97,53z M24,51h72v-2.04C89.63,48.47,84.53,43.37,84.04,37H66.5l-5.7,7.6 c-0.38,0.5-1.22,0.5-1.6,0L53.5,37H35.96C35.47,43.37,30.37,48.47,24,48.96V51z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,45c-0.31,0-0.61-0.14-0.8-0.4l-24-32c-0.3-0.4-0.26-0.96,0.09-1.31l8-8c0.24-0.24,0.57-0.34,0.91-0.27 c0.33,0.07,0.6,0.3,0.73,0.61l16,40c0.19,0.47,0,1-0.44,1.24C60.34,44.96,60.17,45,60,45z M37.32,12.09l18.94,25.26L43.63,5.78 L37.32,12.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54,37H35c-0.55,0-1-0.45-1-1V20c0-0.55,0.45-1,1-1h7c0.31,0,0.61,0.15,0.8,0.4l12,16 c0.23,0.3,0.26,0.71,0.09,1.05C54.72,36.79,54.38,37,54,37z M36,35h16L41.5,21H36V35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85,37H66c-0.38,0-0.72-0.21-0.89-0.55c-0.17-0.34-0.13-0.74,0.09-1.05l12-16c0.19-0.25,0.49-0.4,0.8-0.4h7 c0.55,0,1,0.45,1,1v16C86,36.55,85.55,37,85,37z M68,35h16V21h-5.5L68,35z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22,106.96H6.97c-2.97,0-5.39-2.42-5.39-5.39V46.42C1.58,31.3,13.88,19,29,19h6v2h-6 C14.98,21,3.58,32.4,3.58,46.42v55.16c0,1.87,1.52,3.39,3.39,3.39H22V106.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.1,112.8H5.35v-7.83H24.1V112.8z M7.35,110.8H22.1v-3.83H7.35V110.8z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2.58,
    y: 51.32,
    className: "st0",
    width: 19.42,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.58,
    y: 67.13,
    className: "st0",
    width: 19.42,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.58,
    y: 82.94,
    className: "st0",
    width: 19.42,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.58,
    y: 98.75,
    className: "st0",
    width: 19.42,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.45,
    y: 22.09,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -18.413 25.3978)",
    className: "st0",
    width: 2,
    height: 25.67
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.03,106.96H98v-2h15.03c1.87,0,3.39-1.52,3.39-3.39V46.42C116.42,32.4,105.02,21,91,21h-6v-2h6 c15.12,0,27.42,12.3,27.42,27.42v55.16C118.42,104.55,116,106.96,113.03,106.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.65,112.8H95.9v-7.83h18.75V112.8z M97.9,110.8h14.75v-3.83H97.9V110.8z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 51.32,
    className: "st0",
    width: 19.42,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 67.13,
    className: "st0",
    width: 19.42,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 82.94,
    className: "st0",
    width: 19.42,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 98.75,
    className: "st0",
    width: 19.42,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.71,
    y: 33.93,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 4.1677 79.9132)",
    className: "st0",
    width: 25.67,
    height: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddedJumper);
export default __webpack_public_path__ + "static/media/paddedJumper.04bac502e179316ae0378f6a9d832163.svg";
export { ForwardRef as ReactComponent };